import React, { useEffect } from "react";
import { useLenis } from "./SmoothScroll";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DoneIcon from "@mui/icons-material/Done";
import { Helmet } from "react-helmet-async";

const PatietsBillIrights = () => {
  const patientRights = [
    {
      id: "1",
      title: "Courtesy & Respect",
      description: `Be treated with courtesy and respect, with appreciation of their individual dignity, and with protection of their need for privacy.`,
    },
    {
      id: "2",
      title: "Prompt Response",
      description: `Receive a prompt and reasonable response to questions and requests.`,
    },
    {
      id: "3",
      title: "Provider Information",
      description: `Know who is providing medical services and who is responsible for their care.`,
    },
    {
      id: "4",
      title: "Support Services",
      description: `Know what patient support services are available, including whether an interpreter is available if they do not speak English.`,
    },
    {
      id: "5",
      title: "Informed Consent",
      description: `Be given by the health care provider information concerning diagnosis, planned course of treatment, alternatives, risks, and prognosis.`,
    },
    {
      id: "6",
      title: "Refusal of Care",
      description: `Refuse any treatment, except as otherwise provided by law.`,
    },
    {
      id: "7",
      title: "Financial Counseling",
      description: `Be given, upon request, full information and necessary counseling on the availability of known financial resources for their care.`,
    },
    {
      id: "8",
      title: "Medicare Assignment",
      description: `If eligible for Medicare, to know, upon request and in advance of treatment, whether the health care provider or facility accepts the Medicare assignment rate.`,
    },
    {
      id: "9",
      title: "Cost Estimates",
      description: `Receive, upon request and prior to treatment, a reasonable estimate of charges for medical care.`,
    },
    {
      id: "10",
      title: "Itemized Billing",
      description: `Receive a copy of a reasonably clear and understandable itemized bill and, upon request, to have the charges explained.`,
    },
    {
      id: "11",
      title: "Impartial Access",
      description: `Receive impartial access to medical treatment or accommodations, regardless of race, national origin, religion, physical handicap, or source of payment.`,
    },
    {
      id: "12",
      title: "Emergency Treatment",
      description: `Receive treatment for any emergency medical condition that will deteriorate from failure to provide treatment.`,
    },
    {
      id: "13",
      title: "Grievances",
      description: `Know the facility’s procedures for expressing grievances and to do so without fear of reprisal.`,
    },
  ];

  const patientResponsibilities = [
    {
      id: "1",
      title: "Accurate Information",
      description: `Providing to the health care provider, to the best of their knowledge, accurate and complete information about present complaints, past illnesses, hospitalizations, medications, and other matters relating to their health.`,
    },
    {
      id: "2",
      title: "Reporting Changes",
      description: `Reporting unexpected changes in their condition to the health care provider.`,
    },
    {
      id: "3",
      title: "Understanding Care",
      description: `Reporting to the health care provider whether they comprehend a contemplated course of action and what is expected of them.`,
    },
    {
      id: "4",
      title: "Following Instructions",
      description: `Following the treatment plan recommended by the health care provider.`,
    },
    {
      id: "5",
      title: "Appointments",
      description: `Keeping appointments and, when unable to do so for any reason, notifying the health care provider or health care facility.`,
    },
    {
      id: "6",
      title: "Financial Obligations",
      description: `Assuring that the financial obligations of their health care are fulfilled as promptly as possible.`,
    },
    {
      id: "7",
      title: "Facility Rules",
      description: `Following health care facility rules and regulations affecting patient care and conduct.`,
    },
  ];
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, [lenisRef]);
  return (
    <>
      <Helmet>

         <title> Patient Bill of Rights and HIPAA Compliance | CDC, Florida 
</title>
        <meta
          name="description"
          content="Learn about patient rights in healthcare, patient confidentiality and HIPAA compliance at CDC Florida, including key principles from the patient bill of rights"
        />
        <meta
          name="keywords"
          content="patient confidentiality
patient rights in healthcare
patient bill of rights
HIPAA Compliance

"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 ">
        <div className="lg:w-[90%] w-[95%] mx-auto  flex flex-col items-center  pb-8 lg:pb-16">
          <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 mb-4 text-center capitalize w-full">
            {" "}
            Florida Patient’s Bill of Rights and Responsibilities
          </h1>
          <div className="text-left mt-10">
            <p className="text-[17px] lg:ps-0 md:px-8 px-4 pb-4 text-[#ccc] mt-5 text-left font-robout">
              Florida law requires that your health care provider or health care
              facility recognize your rights while you are receiving medical
              care and that you respect the health care provider’s or health
              care facility’s right to expect certain behavior on the part of
              patients. A summary of your rights and responsibilities follows:
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              A Patient Has the Right To:
            </h2>
            <ul className="flex flex-col text-[17px] gap-3 text-[#ccc]  pb-8  text-left font-robout">
              {patientRights.map((item, index) => (
                <li key={index} className="flex flex-row gap-1 text-[17px]">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                  <p>
                    <span className="text-[#f5f5f5] font-bold px-1.5">
                      {item.title} :{" "}
                    </span>{" "}
                    {item.description}
                  </p>
                </li>
              ))}
            </ul>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              A Patient Is Responsible For:
            </h2>
            <ul className="flex flex-col text-[17px] gap-3 text-[#ccc]  pb-8  text-left font-robout">
              {patientResponsibilities.map((item, index) => (
                <li key={index} className="flex flex-row gap-1 text-[17px]">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                  <p>
                    <span className="text-[#f5f5f5] font-bold px-1.5">
                      {item.title} :{" "}
                    </span>{" "}
                    {item.description}
                  </p>
                </li>
              ))}
            </ul>
            <a
              href="/florida-patient-bill-of-rights.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                const link = document.createElement("a");
                link.href = "/florida-patient-bill-of-rights.pdf";
                link.download = "florida-patient-bill-of-rights.pdf";
                link.click();
              }}
              className="underline hover:text-[#ffffff] text-[#ccc] font-robout font-bold tracking-wider "
            >
              Florida Patient Bill of Rights
            </a>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default PatietsBillIrights;
